import { ActionIcon, Select, SelectProps } from '@mantine/core'
import { IconChevronDown, IconX } from '@tabler/icons-react'

type FilterSelectProps = Omit<SelectProps, 'value' | 'onChange'> & {
  value?: string | null
  onChange?: (value: string | null) => void
}

export const FilterSelect = ({
  value,
  onChange,
  ...props
}: FilterSelectProps) => {
  const handleClear = () => {
    onChange?.(null)
  }

  return (
    <Select
      allowDeselect={false}
      clearable
      {...props}
      value={value}
      rightSection={
        value ? (
          <ActionIcon
            variant="light"
            size={16}
            radius="xl"
            onClick={handleClear}
          >
            <IconX style={{ width: '70%', height: '70%' }} stroke={2} />
          </ActionIcon>
        ) : (
          <IconChevronDown size={16} stroke={2} />
        )
      }
      onChange={onChange}
    />
  )
}
